import { graphql } from 'relay-runtime';

export const ATLASSIAN_ACCOUNT_ANY_USER_QUERY = graphql`
  query AtlassianAccountAnyUserQuery($accountId: ID!) {
    user(accountId: $accountId) {
      ... on AtlassianAccountUser {
        nickname
        picture
      }
    }
  }
`;
